import { CheckCircle2, AlertTriangle, Loader2, Zap } from "lucide-react";
import { inr } from "@/pages/Dashboard";

const LINES = [
  ["cleared_after_as_on", "Open on As-on in SAP, cleared since – not in the extraction"],
  ["posted_after_as_on", "Dated on / before As-on, posted after it"],
  ["dated_after_as_on", "Posted on / before As-on, dated after it"],
  ["outside_scope", "Outside the ageing (special G/L G – security deposits / guarantees)"],
];

const QuickLine = ({ qu }) => {
  if (!qu) return <span className="inline-flex items-center gap-1 text-slate-500"><Loader2 className="h-3 w-3 animate-spin" />Applying SAP changes since the last sync…</span>;
  if (qu.error) return <span className="text-amber-700" data-testid="ageing-quick-update-error">Quick update skipped: {qu.error}</span>;
  return (
    <span className="inline-flex items-center gap-1 text-slate-500" data-testid="ageing-quick-update-status">
      <Zap className="h-3 w-3 text-sky-600" />SAP changes applied {new Date(qu.at).toLocaleTimeString()}: {qu.added} new, {qu.cleared} cleared, {qu.updated} changed · {qu.sap_open_items?.toLocaleString()} open items
    </span>
  );
};

export const AgeingTBTie = ({ data, qu, testPrefix }) => {
  const t = data?.totals;
  return (
    <div className={`rounded-lg border px-4 py-3 text-xs ${t && qu ? (t.ties ? "border-emerald-300 bg-emerald-50/50" : "border-amber-300 bg-amber-50/50") : "border-slate-200 bg-white"}`} data-testid={`${testPrefix}-tb-tie`}>
      {t ? (
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <div><div className="text-[10px] uppercase tracking-wider text-slate-500">Ageing total</div><div className="text-sm font-semibold tabular-nums" data-testid={`${testPrefix}-tie-ageing`}>{inr(t.ageing_total)}</div></div>
          {LINES.filter(([k]) => Math.abs(t[k] || 0) >= 0.5).map(([k, l]) => (
            <div key={k} data-testid={`${testPrefix}-tie-${k}`}><div className="text-[10px] uppercase tracking-wider text-slate-500">{t[k] > 0 ? "+" : "−"} {l}</div><div className="text-sm tabular-nums">{inr(Math.abs(t[k]))}</div></div>
          ))}
          <div><div className="text-[10px] uppercase tracking-wider text-slate-500">= Trial Balance {data.as_on}</div><div className="text-sm font-semibold tabular-nums" data-testid={`${testPrefix}-tie-tb`}>{inr(t.tb_balance)}</div></div>
          {!qu ? (
            <div className="ml-auto inline-flex items-center gap-1 font-semibold text-slate-500" data-testid={`${testPrefix}-tie-status`}><Loader2 className="h-4 w-4 animate-spin" />Checking SAP changes…</div>
          ) : (
          <div className={`ml-auto inline-flex items-center gap-1 font-semibold ${t.ties ? "text-emerald-700" : "text-amber-700"}`} data-testid={`${testPrefix}-tie-status`}>
            {t.ties ? <CheckCircle2 className="h-5 w-5" /> : <AlertTriangle className="h-5 w-5" />}{t.ties ? "Ties to the Trial Balance" : `Unexplained ${inr(t.unexplained)} — see the TB table below`}
          </div>
          )}
        </div>
      ) : <p className="text-slate-500">Loading the Trial Balance tie-out…</p>}
      {t && (Math.abs(t.cleared_since_in_ageing || 0) >= 0.5 || t.excluded?.accounts > 0) && (
        <p className="mt-1.5 text-slate-500" data-testid={`${testPrefix}-tie-info`}>
          {Math.abs(t.cleared_since_in_ageing || 0) >= 0.5 && <span data-testid={`${testPrefix}-tie-cleared-since`}>Includes {inr(t.cleared_since_in_ageing)} of bills open on {data.as_on} and cleared since. </span>}
          {t.excluded?.accounts > 0 && <span data-testid={`${testPrefix}-tie-excluded`}>{t.excluded.accounts} account(s) outside the tie (TB {inr(t.excluded.tb_balance)}) are not counted.</span>}
        </p>
      )}
      <div className="mt-1.5"><QuickLine qu={qu} /></div>
    </div>
  );
};
